import type { AfterViewInit, OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'invd-upload-pool-info-container',
  templateUrl: './upload-pool-info-container.component.html',
  styleUrls: ['./upload-pool-info-container.component.scss'],
})
export class UploadPoolInfoContainerComponent implements OnInit, AfterViewInit {
  public steps: Array<object>;
  public currentStep = '/mega-upload/upload-pool-info';
  public ignoreRoute: boolean;

  private router = inject(Router);

  ngOnInit() {
    this.buildProgressBar();
  }

  ngAfterViewInit() {
    this.router.events.subscribe((event) => {
      if (
        event instanceof NavigationEnd &&
        this.router.url === 'mega-upload/upload-pool-info/confirmation'
      ) {
        this.ignoreRoute = true;
      }
    });
  }

  private buildProgressBar(): void {
    this.steps = [
      {
        title: 'Upload File',
        url: '/mega-upload/upload-pool-info',
      },
      {
        title: 'Validate Pools',
        url: '/mega-upload/upload-pool-info/validate-pools',
      },
      {
        title: 'Allocate Pools',
        url: '/mega-upload/upload-pool-info/allocate-pools',
      },
      {
        title: 'Confirmation',
        url: '/mega-upload/upload-pool-info/confirmation',
      },
    ];
  }
}
